var map = {
	"./bg1.png": "a7b5",
	"./bg2.png": "f6fa",
	"./bg3.png": "4c44",
	"./bg4.png": "91d9",
	"./bg5.png": "2cda",
	"./bg6.png": "d418"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5798";